<template>
  <v-container class="main-container">
    <div class="main-content-area">
        <v-row justify="center">
          <v-col cols="8">
              <v-text-field
                  v-model="keyword"
                  label="　キーワードを入力してください（関連する記事を検索できます）"
                  solo
                  hide-details
                  height="65"
                  class="mt-2 mb-4"
                  type="text"
                  clearable
                  append-icon="mdi-magnify"
                  background-color="white"
                  v-disabled-icon-focus
              ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" class="h3">
          <v-col cols="5">
            カテゴリからさがす
          </v-col>
          <v-col cols="5">
            キーワードからさがす
          </v-col>
        </v-row>
        <v-row justify="center">
          <!--　　category_detailsが未決定のため非表示 　-->
          <!--<v-col cols="5">-->
          <!--  <v-expansion-panels>-->
          <!--    <v-expansion-panel-->
          <!--      v-for="(category, idx) in categories"-->
          <!--      :key="idx"-->
          <!--      class="pa-3 ma-1"-->
          <!--    >-->
          <!--      <v-expansion-panel-header>-->
          <!--        {{ category.category_name }}-->
          <!--      </v-expansion-panel-header>-->
          <!--      <v-expansion-panel-content>-->
          <!--        準備中です-->
          <!--      </v-expansion-panel-content>-->
          <!--    </v-expansion-panel>-->
          <!--  </v-expansion-panels>-->
          <!--</v-col>-->
          <v-col cols="5">
              <v-btn
                rounded
                small
                v-for="(category, idx) in categories"
                :key="idx"
                class="ma-1 white"
                @click="searchWithCategory(category.id)"
                style="text-transform: none"
              >
                {{ category.category_name }}
              </v-btn>
          </v-col>
          <v-col cols="5">
              <v-btn
                rounded
                small
                v-for="(key, idx) in keys"
                :key="idx"
                class="ma-1 white"
                @click="searchWithKeyword(key.id)"
              >
                {{ key.category_name }}
              </v-btn>
          </v-col>
        </v-row>
        <v-row justify="center">
  				<v-col cols="8">
  					<v-card 
                class="mx-auto mt-2 mb-4 py-6 px-6"
                outlined 
                hover
                v-for="(article, idx) in search_articles"
                :key="idx"
                @click="details(article.id)"
              >
  					    <v-card-title v-html="highLight(article.title)"></v-card-title>
								<v-card-subtitle v-html="highLight(article.article_details)"></v-card-subtitle>
            </v-card>
  				</v-col>
  			</v-row>        
    </div>
  </v-container>
</template>

<script>
  export default {
    props: {
        categories: {
          type: Array
        },
        keys: {
          type: Array
        },
        articles: {
          type: Array
        },
    },  
    data: () => ({
      keyword: '',
    }),
    methods:{
      // 検索ボックスに入力されたワードに紐づく記事を表示
      // そのワードに黄色マーカー＆太字に
      highLight(text){
        let searchWord = this.keyword?.trim();
        if (!searchWord) return text;
        if (!text.includes(searchWord)) return text;
        const re = new RegExp(searchWord, 'ig');
        return text.replace(re,function(keyword){
        return '<span style="background-color:yellow;font-weight:bold">'+ keyword + '</span>';
        });
      },
      // ヘルプ記事の中身を表示
      details(id) {
        location.href = "/documents/help_article/view/" + id;
      },
      // 選択されたカテゴリに紐づく記事を表示
      searchWithCategory(id){
        location.href = "/documents/help_article/search_results/" + id;
      },
      // 選択されたキーワードに紐づく記事を表示
      searchWithKeyword(id){
        location.href = "/documents/help_article/search_results/" + id;
      },
    },
    // ヘルプ全記事を初期表示
    computed: {
      search_articles(){
        let searchWord = this.keyword?.trim();
        if (!searchWord) return this.articles;
        return this.articles.filter(article => {
            return article.title.includes(searchWord) ||
            article.article_details.includes(searchWord) ;
        });
      }
  },
};
</script>

<style scoped>
    .main-container {
        margin-right: 0px !important;
        margin-left: 0px !important;
        max-width: none !important;
        height: 100% !important;
    }
    .main-content-area {
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }
</style>